import { CacheExpiryForARIApi } from '../shared/constants/global.constants';
import { ApiService } from '../shared/services/api-service/api.service';
import { CommonService } from '../shared/services/common-service/common.service';
import { IProductService, IProductServiceRequestParams } from './interfaces/product-services.interfaces';

/**
 * @ignore
 */
declare const TCCommonService;

class ProductServicesServiceClass {
    /**
     * Method to get product services
     * @param hotelCode
     * @param requestParams
     * @param disableMonitorRequest
     * @param enableApiCaching
     * @memberof ProductServicesServiceClass
     */
    async getProductServices(hotelCode: number,
        requestParams: IProductServiceRequestParams,
        enableApiCaching: boolean = false,
        disableMonitorRequest: boolean = false,
        currencyCode?: string, tcShareLocation?: boolean,
        loyaltyTierId?: number
    ): Promise<IProductService[]> {
        let queryParams = this._buildRequestQueryParams(requestParams);
        const hashCodeParams = loyaltyTierId ? (queryParams + '&loyaltyTierId=' + loyaltyTierId) : queryParams;
        const cacheKey = 'be_' + TCCommonService.ConfigService.getPlatformType() + '_wc_product_services_' +
            hotelCode + '_' + CommonService.generateHashCode(hashCodeParams);
        if (enableApiCaching) {
            const productServicesDataFromCache = TCCommonService.BrowserStorageService.getBrowserStorage({
                key: cacheKey, expiryTime: CacheExpiryForARIApi
            });
            if (productServicesDataFromCache) {
                return productServicesDataFromCache;
            }
        }

        try {
            const roomSequenceNumberIndex = queryParams.indexOf('&@@roomSequenceNumber');
            if (roomSequenceNumberIndex !== -1) {
                queryParams = queryParams.substring(0, roomSequenceNumberIndex);
            }
            const productServicesApiResponse: Response = await ApiService.getProductServices(hotelCode, queryParams,
                disableMonitorRequest, currencyCode, tcShareLocation, loyaltyTierId
            );
            const productServiceList: IProductService[] = await productServicesApiResponse.json();
            if (enableApiCaching) {
                TCCommonService.BrowserStorageService
                    .setBrowserStorage({ key: cacheKey, value: productServiceList });
            }
            return productServiceList;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }

    /**
     * Method to build query params for a request
     * @param requestParams
     * @memberof ProductServicesServiceClass
     */
    private _buildRequestQueryParams(requestParams: IProductServiceRequestParams): string {
        let queryParams = '';
        for (const key in requestParams) {
            if (Object.prototype.hasOwnProperty.call(requestParams, key) && key !== 'roomSequenceNumber') {
                queryParams = queryParams + '&' + key + '=' + requestParams[key];
            }
        }
        queryParams = queryParams + '&@@roomSequenceNumber=' + String(requestParams['roomSequenceNumber']);
        return queryParams;
    }

}

export const ProductServicesService = new ProductServicesServiceClass();
